import React from 'react'

import { WALKTHROUGH_STEPS_LIST } from '@/components/flows/WalkthroughFlow/constants'
import { useWalkthroughSteps } from '@/components/flows/WalkthroughFlow/hooks/useWalkthroughSteps'
import { THEME_PALETTE } from '@/lib/constants'
import { getCssVariable } from '@/lib/helpers/domHelpers'

const StepIndicators: React.FC = () => {
  const { currentStepIndex } = useWalkthroughSteps()

  return (
    <div className="flex gap-1">
      {WALKTHROUGH_STEPS_LIST.map((step, index) => {
        const isComplete = currentStepIndex >= index

        return (
          <div
            key={step.key}
            className="rounded-full"
            style={{
              backgroundColor: isComplete
                ? getCssVariable('--primary')
                : THEME_PALETTE['gray-500'],
              width: '8px',
              height: '8px',
            }}
          ></div>
        )
      })}
    </div>
  )
}

export default StepIndicators
